import { PRIMARY_REGION } from '@shared/server/regionRouting/constants.js';

// Before residency, every persisted workspace belonged to the primary authority,
// including sessions served by Brazil's edge API.
const migrateWorkspaceRegion = (state) => ({ ...state, workspaceRegion: PRIMARY_REGION });

export default migrateWorkspaceRegion;
